import styled from 'styled-components'

import Text from './Text'

/**
 * 注意テキスト
 */
const WarningText = styled(Text)`
  font-size: 14px;
`

export default WarningText
